import React from "react";

import "./index.scss";

export type ContentProps = React.PropsWithChildren;

export const Content: React.FC<ContentProps> = ({ children }) => {
  return <div className="progress-content">{children}</div>;
};
